import React from 'react';
import PropTypes from 'prop-types';

function HeaderBanner({ slot1, heading }) {
  return (
    <div className="flex items-center px-4 py-2 tracking-wider text-white uppercase sm:px-6 lg:px-8 bg-light-pink">
      <div className="w-1/3 text-sm">{slot1}</div>
      <div className="w-1/3 text-center">
        <h1 className="font-medium">{heading}</h1>
      </div>
    </div>
  );
}

HeaderBanner.propTypes = {
  slot1: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
};

export { HeaderBanner };
